"use strict";

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withScrollbars = require("../../hoc/withScrollbars");

var _withScrollbars2 = _interopRequireDefault(_withScrollbars);

var _logoGenWhite = require("../../images/logo-gen-white");

var _logoGenWhite2 = _interopRequireDefault(_logoGenWhite);

var _logoGenBlack = require("../../images/logo-gen-black");

var _logoGenBlack2 = _interopRequireDefault(_logoGenBlack);

var _NewLogo = require("../Icons/NewLogo");

var _NewLogo2 = _interopRequireDefault(_NewLogo);

var _LogoSp = require("../Icons/LogoSp");

var _LogoSp2 = _interopRequireDefault(_LogoSp);

var _reactRouterDom = require("react-router-dom");

var _UnauthorizedMenu = require("./components/UnauthorizedMenu");

var _UnauthorizedMenu2 = _interopRequireDefault(_UnauthorizedMenu);

var _HeaderNew = require("../HeaderNew");

var _HeaderNew2 = _interopRequireDefault(_HeaderNew);

var _AuthorizedMenu = require("./components/AuthorizedMenu");

var _AuthorizedMenu2 = _interopRequireDefault(_AuthorizedMenu);

var _themes = require("../../constants/themes");

var _themes2 = _interopRequireDefault(_themes);

var _styled = require("./styled");

var _styled2 = _interopRequireDefault(_styled);

var _place = require("../../constants/place");

var _place2 = _interopRequireDefault(_place);

var _urlLocations = require("../../routes/urlLocations");

var _MobileMenu = require("./components/MobileMenu");

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _withScreenSize = require("../../hoc/withScreenSize");

var _withScreenSize2 = _interopRequireDefault(_withScreenSize);

var _IsUser = require("../../utils/user/IsUser");

var _IsUser2 = _interopRequireDefault(_IsUser);

var _getSubDomain = require("../../utils/getSubDomain");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var slogan = "Connecting companies \n and sophisticated investors";
var mainSlogan = "Simple by design";
var subDomain = (0, _getSubDomain.getSubDomain)();
var hasSubdomain = subDomain !== 'www';

var getUserTypeLabel = function getUserTypeLabel(userType, userRoleName) {
  var types = {
    DEFAULT: "DEFAULT",
    ADVISOR: "ADVISOR",
    ISSUER: "ISSUER",
    INVESTOR: "INVESTOR",
    SUPER_ADMIN: "ADMIN",
    ADMIN_STRATEGIC_PARTNER: "ADMIN",
    WORKER_STRATEGIC_PARTNER: "RELATIONSHIP MANAGER",
    ISSUER_STRATEGIC_PARTNER: "ISSUER",
    INVESTOR_STRATEGIC_PARTNER: "INVESTOR",
    COMPLIANCE_OFFICER_STRATEGIC_PARTNER: "COMPLIANCE OFFICER",
    OTHER_STRATEGIC_PARTNER: userRoleName
  };
  return types[userType] || types.DEFAULT;
};

var HeaderComponent =
/*#__PURE__*/
function (_react$Component) {
  _inherits(HeaderComponent, _react$Component);

  function HeaderComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HeaderComponent);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderComponent)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.renderRoleDetails = function (userType, roleType, spPlatformConfig, isMobile, isTablet, userRoleName) {
      var title = _this.props.title;
      var userTypeLabel = getUserTypeLabel(userType, userRoleName);
      var isUser = new _IsUser2.default(userType);
      var isSp = isUser.allSP;
      var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : "#1496af";

      if (userType === 'ISSUER_STRATEGIC_PARTNER' && (roleType === 'INTERNAL' || roleType === 'EXTERNAL')) {
        userTypeLabel = "".concat(roleType.toUpperCase(), " ISSUER");
      }

      if (userType && !isMobile) {
        return _react2.default.createElement(_styled2.default.UserRoleWrapper, null, _react2.default.createElement(_styled2.default.UserRole, {
          isSp: isSp,
          accentColor: accentColor
        }, userTypeLabel));
      }

      return !spPlatformConfig && _react2.default.createElement(_styled2.default.Slogan, null, slogan);
    }, _this.MobileSection = function (_ref) {
      var logoImg = _ref.logoImg,
          userType = _ref.userType,
          roleType = _ref.roleType,
          spPlatformConfig = _ref.spPlatformConfig,
          userRoleName = _ref.userRoleName;
      var isUser = new _IsUser2.default(userType);
      var isSp = isUser.allSP;
      var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : "#1496af";
      var userTypeLabel = getUserTypeLabel(userType, userRoleName);

      if (userType === 'ISSUER_STRATEGIC_PARTNER' && (roleType === 'INTERNAL' || roleType === 'EXTERNAL')) {
        userTypeLabel = "".concat(roleType.toUpperCase(), " ISSUER");
      }

      return _react2.default.createElement(_styled2.default.MobileSection, null, logoImg, userType && _react2.default.createElement(_styled2.default.UserRoleMobile, {
        isSp: isSp,
        accentColor: accentColor
      }, userTypeLabel));
    }, _this.renderMenu = function (props, userType) {
      var spPlatformConfig = props.spPlatformConfig;
      var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : "#1496af";
      var isUser = new _IsUser2.default(userType);
      var isSp = isUser.allSP;
      return _react2.default.createElement(_react2.default.Fragment, null, userType ? _react2.default.createElement(_AuthorizedMenu2.default, _extends({}, props, {
        place: _place2.default.Header,
        isSp: isSp,
        accentColor: accentColor
      })) : _react2.default.createElement(_HeaderNew2.default, null));
    }, _temp));
  }

  _createClass(HeaderComponent, [{
    key: "isUnauthorizedMenuShown",
    value: function isUnauthorizedMenuShown() {
      var user = this.props.user;
      var userType = user && user.userType;
      return !userType;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentPage = _this$props.currentPage,
          user = _this$props.user,
          userTheme = _this$props.userTheme,
          isAdminPlatform = _this$props.isAdminPlatform,
          unread = _this$props.unread,
          isUserFetching = _this$props.isUserFetching,
          _this$props$scrollbar = _this$props.scrollbar,
          needToFixedHeaders = _this$props$scrollbar.needToFixedHeaders,
          handleMobileMenuStatus = _this$props$scrollbar.handleMobileMenuStatus,
          setLogoutModalVisible = _this$props.setLogoutModalVisible,
          spPlatformConfig = _this$props.spPlatformConfig,
          screenSize = _this$props.screenSize,
          sidebarComponent = _this$props.sidebarComponent;
      var isMobile = screenSize.isMobile,
          isTablet = screenSize.isTablet;
      var userType = user && user.userType;
      var roleType = user && user.roleType;
      var userRoleName = user && user.userRoleName;
      var DefaultLogo = userTheme === _themes2.default.BLACK ? _logoGenWhite2.default : _logoGenBlack2.default;
      var isUser = new _IsUser2.default(user && user.userType);
      var isSp = isUser.allSP;
      var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : '#1496af';
      var logoImg = spPlatformConfig && spPlatformConfig.logo ? _react2.default.createElement(_reactRouterDom.Link, {
        to: "/projects/all"
      }, _react2.default.createElement(_styled2.default.LogoImg, {
        src: spPlatformConfig.logo.link,
        alt: 'logo'
      })) : isSp ? _react2.default.createElement(_LogoSp2.default, null) : _react2.default.createElement(_NewLogo2.default, null);
      return _react2.default.createElement(_styled2.default.Header, {
        id: "header",
        accentColor: accentColor,
        isSp: isSp,
        needToFixedHeaders: needToFixedHeaders
      }, _react2.default.createElement(_styled2.default.Logo, null, this.props.showLogo && _react2.default.createElement(_styled2.default.LogoShort, null, _react2.default.createElement(_styled2.default.LogoInnerLink, {
        to: isAdminPlatform ? _urlLocations.projects : _urlLocations.stubPage
      }, logoImg)), _react2.default.createElement(_styled2.default.TitleSection, null, isUserFetching ? null : this.renderRoleDetails(userType, roleType, spPlatformConfig, isMobile, isTablet, userRoleName), isMobile ? this.MobileSection({
        logoImg: logoImg,
        userType: userType,
        spPlatformConfig: spPlatformConfig,
        roleType: roleType
      }) : _react2.default.createElement(_styled2.default.Title, null, currentPage))), isUserFetching ? null : this.renderMenu(this.props, userType), _react2.default.createElement(_MobileMenu2.default, {
        isSp: isSp,
        sidebarComponent: sidebarComponent,
        userTheme: userTheme,
        setLogoutModalVisible: setLogoutModalVisible,
        user: user,
        isAdminPlatform: isAdminPlatform,
        unread: unread,
        userType: userType,
        setMobileMenuStatus: function setMobileMenuStatus(status) {
          return handleMobileMenuStatus(status);
        },
        spPlatformConfig: spPlatformConfig
      }));
    }
  }]);

  return HeaderComponent;
}(_react.Component);

HeaderComponent.defaultProps = {
  showLogo: true,
  logoUrl: null,
  userTheme: null,
  isUserFetching: false,
  isAdminPlatform: false,
  platform: ""
};
HeaderComponent.propTypes = {
  title: _propTypes2.default.any,
  showLogo: _propTypes2.default.bool,
  isAdminPlatform: _propTypes2.default.bool,
  isUserFetching: _propTypes2.default.bool,
  logoUrl: _propTypes2.default.string,
  path: _propTypes2.default.string,
  platform: _propTypes2.default.string,
  setLogoutModalVisible: _propTypes2.default.func,
  user: _propTypes2.default.shape(),
  userTheme: _propTypes2.default.string
};
exports.default = (0, _withScreenSize2.default)((0, _withScrollbars2.default)(HeaderComponent));